import React from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Header from './../../component/common/Header';
import Loader from './../../component/common/Loader';
import { ToastContainer, toast } from 'react-toastify';

import CONSTANT from './../../constant';
import { onChange, setOptions, getDateParts, getProfilePictureUrl } from './../../utils';
import { getCircualrAccessList, getProfileDetail, getUserSummaryList, updateAccessList, updateContactList, uploadProfilePicture } from './../../actions/UserAction';

class ComponentName extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            departmentCode: { name: 'departmentCode', value: '', options: [], error: '', isRequired: true },
            gradeCode: { name: 'gradeCode', value: '', options: [], error: '', isRequired: true },
            groupCode: { name: 'groupCode', value: '', options: [], error: '', isRequired: true },
            designationCode: { name: 'designationCode', value: '', options: [], error: '', isRequired: true },
            unitCode: { name: 'unitCode', value: '', options: [], error: '', isRequired: true },
            employeeNumber: { name: 'employeeNumber', value: '', error: '', isRequired: true },
            isHOD: { name: 'isHOD', value: false, error: '', isRequired: true },
            name: { name: 'name', value: '', error: '', isRequired: true },
            email: { name: 'email', value: '', error: '', isRequired: true },
            mobile: { name: 'mobile', value: '', error: '', isRequired: true },
            dob: { name: 'dob', value: '', error: '', isRequired: false },
            doj: { name: 'doj', value: '', error: '', isRequired: false },
            profilePicture: { name: 'profilePicture', value: '', error: '', isRequired: false },
            showLoader: false,
            contactList: { name: 'contactList', value: [], error: '', isRequired: true, options: [] },
            circularListUploadAccess: { name: 'circularListUploadAccess', value: [], error: '', isRequired: true, options: [] },
            profilePictureUrl: '',
            uploadingPicture: false,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.profile;

        this.setState({ showLoader: true });

        getProfileDetail().then((res: any) => {
            this.setState({ showLoader: false });
            if (res) {
                if (res.status === CONSTANT.static.apiStatus.success) {
                    const detail = res.result.detail;
                    const dob = getDateParts(detail.dob);
                    const doj = getDateParts(detail.doj);

                    const picUrl = getProfilePictureUrl(detail.profilePicture);

                    this.setState((prevState: any) => ({
                        ...prevState,
                        name: { ...prevState.name, value: detail.name },
                        email: { ...prevState.email, value: detail.email },
                        employeeNumber: { ...prevState.employeeNumber, value: detail.employeeNumber },
                        mobile: { ...prevState.mobile, value: detail.mobile },
                        isHOD: { ...prevState.isHOD, value: detail.isHOD },
                        departmentCode: { ...prevState.departmentCode, value: detail.departmentName },
                        designationCode: { ...prevState.designationCode, value: detail.designationName },
                        gradeCode: { ...prevState.gradeCode, value: detail.gradeName },
                        groupCode: { ...prevState.groupCode, value: detail.groupName },
                        unitCode: { ...prevState.unitCode, value: detail.unitName },
                        dob: { ...prevState.dob, value: `${dob.year}-${dob.month}-${dob.date}` },
                        doj: { ...prevState.doj, value: `${doj.year}-${doj.month}-${doj.date}` },
                        contactList: { ...prevState.contactList, value: res.result.contactList },
                        profilePictureUrl: picUrl,
                    }));
                }
            }
        });

        getUserSummaryList().then((res: any) => {
            setOptions(this, this.state.contactList.name, res.result);
        });

        getCircualrAccessList().then((res: any) => {
            if (res.status === CONSTANT.static.apiStatus.success) {
                setOptions(this, this.state.circularListUploadAccess.name, res.result)
                this.setState({ ...this.state, ['circularListUploadAccess']: { ...this.state.circularListUploadAccess, value: this.state.circularListUploadAccess.options.filter((item: any) => item.circularAccess == true) } })

            }
        }).catch((arr: any) => {
            console.log("err")
        })


    }


    updateAccessListOfCircularModule() {
        const { circularListUploadAccess } = this.state

        let access_list = circularListUploadAccess.value.map((ele: any) => {
            return { userCode: ele.code }
        })

        updateAccessList({ userList: access_list }).then((res: any) => {
            if (res.status === CONSTANT.static.apiStatus.success) {
                this.succesMessage("updated")
            } else {
                this.errorMessage(res.error)

            }

        }).catch((err: any) => {
            this.errorMessage(err)
        })


    }



    succesMessage(msg: string) {

        toast.success(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }

    errorMessage(msg: String) {
        toast.error(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }



    onProfilePictureChange = (e: any) => {
        const file = e.target.files[0];
        if (!file) return;

        const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        if (!validTypes.includes(file.type)) {
            this.errorMessage('Please select a valid image file (JPEG or PNG)');
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            this.errorMessage('Image size should be less than 5MB');
            return;
        }

        this.setState({ uploadingPicture: true });
        uploadProfilePicture(file).then((res: any) => {
            this.setState({ uploadingPicture: false });
            if (res && res.status === CONSTANT.static.apiStatus.success) {
                this.setState({ profilePictureUrl: getProfilePictureUrl(res.result.profilePicture) });
                this.succesMessage('Profile picture updated successfully');
            } else if (res) {
                this.errorMessage(res.error || 'Failed to upload profile picture');
            }
        }).catch(() => {
            this.setState({ uploadingPicture: false });
            this.errorMessage('Failed to upload profile picture');
        });
    }

    render() {
        const { employeeNumber, isHOD, name, email, mobile, departmentCode, gradeCode, groupCode, designationCode, unitCode, dob, doj } = this.state;
        const { contactList, showLoader, circularListUploadAccess, profilePictureUrl, uploadingPicture } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">User detail</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        Profile information
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12 mb-4">
                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 24 }}>
                                                    <div style={{ flexShrink: 0 }}>
                                                        {profilePictureUrl ? (
                                                            <img
                                                                src={profilePictureUrl}
                                                                alt="Profile"
                                                                style={{
                                                                    width: 120,
                                                                    height: 120,
                                                                    borderRadius: '50%',
                                                                    objectFit: 'cover',
                                                                    border: '3px solid #dee2e6',
                                                                    display: 'block'
                                                                }}
                                                            />
                                                        ) : (
                                                            <div style={{
                                                                width: 120,
                                                                height: 120,
                                                                borderRadius: '50%',
                                                                backgroundColor: '#e9ecef',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontSize: 42,
                                                                fontWeight: 600,
                                                                color: '#6c757d',
                                                                border: '3px solid #dee2e6'
                                                            }}>
                                                                {name.value ? name.value.charAt(0).toUpperCase() : '?'}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <label
                                                            className="btn submit-button btn-sm mb-0"
                                                            style={{ cursor: 'pointer', padding: '8px 20px', fontSize: 14 }}
                                                        >
                                                            {uploadingPicture ? 'Uploading...' : 'Upload Photo'}
                                                            <input
                                                                type="file"
                                                                accept="image/jpeg,image/png"
                                                                style={{ display: 'none' }}
                                                                onChange={this.onProfilePictureChange}
                                                                disabled={uploadingPicture}
                                                            />
                                                        </label>
                                                        <p style={{ fontSize: 12, color: '#6c757d', marginBottom: 0, marginTop: 8 }}>
                                                            JPEG or PNG, max 5MB
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Employee #</label>
                                                    <input
                                                        type="text"
                                                        className={employeeNumber.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        placeholder="Employee number"
                                                        name={employeeNumber.name}
                                                        value={employeeNumber.value}
                                                        onChange={this.onChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-9">
                                                <div className="form-group">
                                                    <label>Employee name</label>
                                                    <input
                                                        type="text"
                                                        className={name.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        placeholder="Name of the employee"
                                                        name={name.name}
                                                        value={name.value}
                                                        onChange={this.onChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Employee email</label>
                                                    <input
                                                        type="text"
                                                        className={email.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        placeholder="Email of the employee"
                                                        name={email.name}
                                                        value={email.value}
                                                        onChange={this.onChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Employee mobile</label>
                                                    <input
                                                        type="text"
                                                        className={mobile.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        placeholder="Mobile number of the employee"
                                                        name={mobile.name}
                                                        value={mobile.value}
                                                        onChange={this.onChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group d-none">
                                                    <label>DOB</label>
                                                    <input
                                                        type="date"
                                                        className={dob.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        placeholder="Mobile number of the employee"
                                                        name={dob.name}
                                                        value={dob.value}
                                                        onChange={this.onChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group d-none">
                                                    <label>DOJ</label>
                                                    <input
                                                        type="date"
                                                        className={doj.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        placeholder="Mobile number of the employee"
                                                        name={doj.name}
                                                        value={doj.value}
                                                        onChange={this.onChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Department</label>
                                                    <input
                                                        type="text"
                                                        className={departmentCode.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        placeholder="Name of department"
                                                        name={departmentCode.name}
                                                        value={departmentCode.value}
                                                        onChange={this.onChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Is Department HOD?</label>
                                                    <input
                                                        type="text"
                                                        className={isHOD.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        placeholder="HOD"
                                                        name={isHOD.name}
                                                        value={isHOD.value ? 'Yes' : 'No'}
                                                        onChange={this.onChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Designation</label>
                                                    <input
                                                        type="text"
                                                        className={designationCode.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        placeholder="Your designation"
                                                        name={designationCode.name}
                                                        value={designationCode.value}
                                                        onChange={this.onChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Grade</label>
                                                    <input
                                                        type="text"
                                                        className={gradeCode.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        placeholder="Your grade"
                                                        name={gradeCode.name}
                                                        value={gradeCode.value}
                                                        onChange={this.onChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Group</label>
                                                    <input
                                                        type="text"
                                                        className={groupCode.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        placeholder="Your group"
                                                        name={groupCode.name}
                                                        value={groupCode.value}
                                                        onChange={this.onChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Unit</label>
                                                    <input
                                                        type="text"
                                                        className={unitCode.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        placeholder="Unit"
                                                        name={unitCode.name}
                                                        value={unitCode.value}
                                                        onChange={this.onChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="row mt-3">
                            <div className="col-md-12">
                                <div className="card">

                                    <div className="card-header">
                                        My contact list
                                    </div>

                                    <div className="card-body">
                                        <form onSubmit={this.onSubmit}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        {/* <label>Contact list</label> */}
                                                        <Typeahead
                                                            flip={true}
                                                            id="ta-contact-list"
                                                            labelKey={(option: any) => `${option.name} (${option.employeeNumber})`}
                                                            name={contactList.name}
                                                            selected={contactList.value}
                                                            multiple={true}
                                                            options={contactList.options}
                                                            onChange={(e: any) => this.typeaheadOnChange(contactList.name, e)}
                                                            placeholder=""
                                                            isInvalid={contactList.error.length > 0}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-9"></div>
                                                <div className="col-md-3">
                                                    <button type="submit" className="btn btn-block submit-button btn-sm">Update Contact List</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {this.state.isHOD.value && <div className="row mt-3">
                            <div className="col-md-12">
                                <div className="card">

                                    <div className="card-header">
                                        Circular Upload Access
                                    </div>

                                    <div className="card-body">
                                        <form onSubmit={(e) => {
                                            e.preventDefault()
                                            this.updateAccessListOfCircularModule()
                                        }}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        {/* <label>Contact list</label> */}
                                                        <Typeahead
                                                            flip={true}
                                                            id="ta-contact-list"
                                                            labelKey={(option: any) => `${option.name} (${option.employeeNumber})`}
                                                            name={circularListUploadAccess.name}
                                                            selected={circularListUploadAccess.value}
                                                            multiple={true}
                                                            options={circularListUploadAccess.options}
                                                            onChange={(e: any) => {
                                                                this.setState({ ...this.state, ['circularListUploadAccess']: { ...circularListUploadAccess, value: e } })
                                                            }}
                                                            placeholder=""
                                                            isInvalid={circularListUploadAccess.error.length > 0}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-9"></div>
                                                <div className="col-md-3">
                                                    <button type="submit" className="btn btn-block submit-button btn-sm"> Update access  List</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        }

                    </div>
                </div>

                {
                    showLoader && <Loader />
                }

                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                {/* Same as */}
                <ToastContainer />
            </div>
        )
    }

    typeaheadOnChange = (name: string, e: any) => {
        let value = e;

        const { isHOD } = this.state
        if (e.length > 0 && e[0].customOption) {
            value = [{ name: e[0].name }];
        }

        // 3963, 2111,116 these all are CMD , only HOD can add CMD

        if ([3963, 2111, 116].includes(e[e.length - 1].employeeNumber)) {
            if (isHOD.value) {
                onChange(this, name, value);
            }
            else {
                e.pop()
                toast.error('You are not authorised user to add this User in your contact List ', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return
            }
        }



        onChange(this, name, value);
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        this.setState({ showLoader: true });
        const { contactList } = this.state;
        const model = {
            contactList: contactList.value.map((i: any) => i.code).join(',')
        };

        updateContactList(model).then((res: any) => {
            this.setState({ showLoader: false });
            if (res.status === CONSTANT.static.apiStatus.success) {
                alert('Changes were saved successfully');
            } else {
                alert(res.error);
            }
        })
    }
}

export default ComponentName;